export const ERROR_HEADER = 'error-header';
export const ERROR_INPUT = 'error-input';
export const ERROR_ROW = 'error-row';
export const WARNING_INPUT = 'warning-input';
